import React from "react";
import "./FocusPage1.css";

function FocusPage1() {
  return (
    <div className="top-focus">

      {/* Intro */}
      <div className="container focus-table">
        <h1><strong>We Focus On 3 Things</strong></h1>
        <p>
          Our mission is rather simple; Global Suntec is committed to help its
          customers with their goal and driving ambition to be the trusted
          partner of their choice, delivering reliable, complete floating
          production solutions that create value for our clients.
        </p>
      </div>

      {/* TECHNOLOGY */}
      <div className="container technology-sec">
        <h1 className="technology-heading"><strong>Technology</strong></h1>

        <div className="row technology-data">
          <div className="technology-img col-lg-6 col-md-12">
            <img src="service-pic/technology_2.jpg" alt="technology" />
          </div>

          <div className="technology-content-sec col-lg-6 col-md-12">
            <p className="technology-para">
              Technology plays a major role in automation, productivity and
              efficiency. We help businesses leverage modern solutions to
              overcome challenges and achieve their goals with ease.
            </p>
          </div>
        </div>
      </div>

      {/* METHODOLOGY */}
      <div className="container technology-sec">
        <h1 className="technology-heading"><strong>Methodology</strong></h1>

        <div className="row technology-data reverse">
          <div className="technology-content-sec col-lg-6 col-md-12">
            <p className="technology-para">
              Choosing the right methodology is crucial. We combine modern
              frameworks and proven processes to deliver efficient and scalable
              solutions tailored to your business needs.
            </p>
          </div>

          <div className="technology-img col-lg-6 col-md-12">
            <img src="service-pic/methodology.jpg" alt="methodology" />
          </div>
        </div>
      </div>

      {/* BUSINESS */}
      <div className="container technology-sec">
        <h1 className="technology-heading"><strong>Business Challenges</strong></h1>

        <div className="row technology-data">
          <div className="technology-img col-lg-6 col-md-12">
            <img src="service-pic/businesschallenges.jpg" alt="business challenges" />
          </div>

          <div className="technology-content-sec col-lg-6 col-md-12">
            <p className="technology-para">
              We help organizations tackle complex challenges by providing smart
              solutions. Our expertise ensures better decision making, improved
              efficiency and long-term growth.
            </p>
          </div>
        </div>
      </div>

    </div>
  );
}

export default FocusPage1;